import { useRootStore } from 'mobx-stores/store-provider';
import {useDropzone} from 'react-dropzone';
import styles from './drop-images-container.module.scss'
import { observer } from 'mobx-react-lite';

const DropImagesContainer = (props) => {
  const {
      width,
      height,
      square
  } =  props

  const {
     imagesStore: {
        setSquareCropImage,
        setBackgroundCropImage
     }
  } = useRootStore()

  const {getRootProps, getInputProps} = useDropzone({
    accept: ['image/png', 'image/jpeg', 'video/mp4'],
    onDrop: acceptedFiles => {
        const fileArr = acceptedFiles.map(file => Object.assign(file, {
            file: file,
            link: URL.createObjectURL(file),
            x: 0,
            y: 0,
            zoom: 1
        }));
        if(square) {
            setSquareCropImage(fileArr)
        } else if(!square) {
            setBackgroundCropImage(fileArr)
        } else {
            setSquareCropImage(fileArr)
        }
      }
  });

  return (
    <section className="container">
      <div {...getRootProps({className: 'dropzone'})} className={styles.dropContainer} style={{ width: width, height: height}}>
        <input {...getInputProps()} />
        <div className={styles.plusAddImage}>
            <span>+</span>
            <p>Add image</p>
        </div>
      </div>
    </section>
  );
}

const DropImages = observer(DropImagesContainer)
export { DropImages }